import React, { useState, useEffect } from 'react';

const PrinterConfig = ({ config, setConfig, devices, onConnect }) => {
	const [availablePrinters, setAvailablePrinters] = useState([]);
	const [testing, setTesting] = useState(false);
	const [connecting, setConnecting] = useState(false);

	useEffect(() => {
		refreshPrinters();
	}, []);

	const refreshPrinters = async () => {
		try {
			// In a real implementation, this would call the printer API
			// For now, we'll simulate some common printer types
			const mockPrinters = [
				{ name: 'Thermal_Printer_80mm', displayName: 'Thermal Printer (80mm)' },
				{ name: 'Thermal_Printer_58mm', displayName: 'Thermal Printer (58mm)' },
				{ name: 'Generic_Receipt_Printer', displayName: 'Generic Receipt Printer' },
				{ name: 'USB_Thermal_Printer', displayName: 'USB Thermal Printer' }
			];

			// Get Real printers from the printer API
			const printers = await window.printerAPI.listPrinters();

			// Simulate loading delay
			// await new Promise(resolve => setTimeout(resolve, 500));
			setAvailablePrinters(printers);
		} catch (error) {
			console.error('Failed to load printers:', error);
			setAvailablePrinters([]);
		}
	};

	const testPrinter = async () => {
		if (!config.printer) {
			alert('Please select a printer first');
			return;
		}

		setTesting(true);
		try {
			// Simulate test print
			// await new Promise(resolve => setTimeout(resolve, 1000));

			// In a real implementation, this would send a test page to the printer
			const testReceipt = [
				'TRUCKSCALE PRO',
				'TEST PRINT',
				'================',
				`Date: ${new Date().toLocaleDateString()}`,
				`Time: ${new Date().toLocaleTimeString()}`,
				`Printer: ${config.printer}`,
				`Paper Width: ${config.paperWidth}`,
				'================',
				'Test successful!'
			];

			// // console.log('Test print:', testReceipt);

			window.printerAPI.printJob({
				printerName: document.getElementById('printerSelect').value,
				paperWidth: config.paperWidth,
				font: "A",
				align: "center",
				style: "b",
				// size: [2, 2],
				text: testReceipt,
			}).then(response => {
				// console.log('Print response:', response);
			}).catch(err => {
				console.error('Print error:', err);
			});

			alert('Test print sent successfully! Check your printer.');
		} catch (error) {
			console.error('Test print failed:', error);
			alert('Test print failed. Please check your printer connection.');
		} finally {
			setTesting(false);
		}
	};

	const handleConnect = async () => {
		if (!config.printer) {
			alert('Please select a printer first');
			return;
		}

		setConnecting(true);
		try {
			await onConnect('printer', { name: config.printer });
			alert('Printer connected successfully!');
		} catch (error) {
			console.error('Failed to connect printer:', error);
			alert('Failed to connect to printer. Please try again.');
		} finally {
			setConnecting(false);
		}
	};

	return (
		<div className="card">
							<h3><i className="fas fa-print"></i> Printer Settings</h3>

			<div className="form-group">
				<label className="form-label">Select Printer</label>
				<div style={{ display: 'flex', gap: '0.5rem' }}>
					<select
						className="form-select"
						id="printerSelect"
						value={config.printer}
						onChange={(e) => setConfig({...config, printer: e.target.value})}
						style={{ flex: 1 }}
					>
						<option value="">Select printer...</option>
						{availablePrinters.map(printer => (
							<option key={printer.name} value={printer.name}>
								{printer.displayName}
							</option>
						))}
					</select>
					<button
						className="btn btn-secondary btn-small"
						onClick={refreshPrinters}
						title="Refresh printer list"
					>
						<i className="fas fa-sync"></i>
					</button>
				</div>
			</div>

			<div className="form-group">
				<label className="form-label">Paper Width</label>
				<select
					className="form-select"
					value={config.paperWidth}
					onChange={(e) => setConfig({...config, paperWidth: e.target.value})}
				>
					<option value="44mm">44mm</option>
					<option value="57mm">57mm</option>
					<option value="58mm">58mm</option>
					<option value="58mm">76mm</option>
					<option value="78mm">78mm</option>
					<option value="80mm">80mm</option>
				</select>
			</div>

			{devices.printer.connected && (
				<div className="alert alert-success">
					<i className="fas fa-check-circle" style={{ color: '#28a745' }}></i> Connected to: {devices.printer.name}
				</div>
			)}

			<div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
				<button
					className="btn btn-secondary"
					onClick={testPrinter}
					disabled={!config.printer || testing}
				>
					{testing ? 'Testing...' : <><i className="fas fa-print"></i> Test Print</>}
				</button>
				<button
					className="btn btn-success"
					onClick={handleConnect}
					disabled={!config.printer || connecting || devices.printer.connected}
				>
					{connecting ? 'Connecting...' : devices.printer.connected ? 'Connected' : '🔗 Connect'}
				</button>
			</div>

			<div style={{ marginTop: '1rem', fontSize: '0.875rem', color: '#718096' }}>
				<p><strong>Note:</strong> Make sure your thermal printer is connected via USB or network and has paper loaded.</p>
			</div>
		</div>
	);
};

export default PrinterConfig;